import script from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=7b57ce22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b57ce22"]])

export default __exports__